
const companyInfo = [
    {
        name: "公司名称",
        key: "store_name",
    },
    {
        name: "联系人",
        key: "contacts",
    },
    {
        name: "联系电话",
        key: "contacts_phone1",
    },
    {
        name: "联系电话2",
        key: "contacts_phone2",
    },
    // {
    //     name: "电子邮箱",
    //     key: "wechat",
    // },
    {
        name: "地址",
        key: "address",
    },
    {
        name: "备注",
        key: "desc",
    },
    {
        name: "加入日期",
        key: "create_time",
    },
    {
        name: "有效期",
        key: "end_time",
    },
    // {
    //     name: "剩余短信",
    //     key: "entry_time",
    // },
];
import { defineComponent, inject, ref } from "vue";
import { getCompanyInfo } from "@/api/http";

export default defineComponent({
    name: "userCompany",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["公司信息"]);
        let companyData = ref({});
        getCompanyInfo().then((res: any) => {
            companyData.value = res?.content;
        });
        return {
            companyInfo,
            companyData,
        };
    },
});
